import script from "./PCLectorPaleAndElaborateArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./PCLectorPaleAndElaborateArticles.vue?vue&type=script&setup=true&lang=js"

import "./PCLectorPaleAndElaborateArticles.vue?vue&type=style&index=0&id=2d88ff70&lang=scss"

const __exports__ = script;

export default __exports__